import * as React from "react";
import QRCode, { toBuffer } from "qrcode";
import type { Branded } from "io-ts";

interface QrDataUrlBrand {
    readonly QrDataUrl: unique symbol;
}
export type QrDataUrl = Branded<string, QrDataUrlBrand>;

export const qrDataUrl = (source: string) =>
    QRCode.toDataURL(source) as Promise<QrDataUrl>;

export const qrBuffer = (source: string) => QRCode.toBuffer(source);

interface Props {
    url: QrDataUrl | string;
    title: string;
}

export const QrCode = (p: Props) => {
    return (
        <div style={{ float: "left" }}>
            <div
                style={{
                    border: "1px solid rgb(170, 170, 170)",
                }}
            >
                <img src={p.url} alt={p.title} />
            </div>
            <span
                style={{
                    position: "relative",
                    top: "-0.3cm",
                    left: "0.2cm",
                    backgroundColor: "white",
                    padding: "0.1cm",
                }}
            >
                {p.title}
            </span>
        </div>
    );
};
